module.exports = __webpack_public_path__ + "static/DonaAlt-Medium-65028602173c8e181a26500b7fdcd41f.eot";